<div class="performance-page">
  <div class="page-header">
    <h1 class="page-title">
      <i class="fa-solid fa-gauge"></i>
      {{ 'Performance' | navTitle | async }}
    </h1>
    <button class="filter-toggle-btn" (click)="toggleFilters()" 
            [pTooltip]="filtersVisible ? ('hide_filters'|translate) : ('show_filters'|translate)" 
            tooltipPosition="left">
      <i class="fa-solid" [ngClass]="filtersVisible ? 'fa-filter-circle-xmark' : 'fa-filter'"></i>
      <span>{{ filtersVisible ? ('hide_filters'|translate) : ('show_filters'|translate) }}</span>
    </button>
  </div>

  <!-- Filters Section -->
  <div class="filters-container" [@slideDown] *ngIf="filtersVisible">
    <div class="filter-row">
      <!-- Strategy -->
      <div class="filter-section">
        <label class="filter-label">
          <i class="fa-solid fa-bullseye"></i>
          {{'strategy'|translate}}
        </label>
        <div class="dropdown-wrapper">
          <p-dropdown (onChange)="strategyOptionsChange()" [(ngModel)]="selectedStrategyId"
            [options]="strategyOptions" optionLabel="name" optionValue="strategyId"
            placeholder="{{'select_strategy'|translate}}"></p-dropdown>
        </div>
      </div>

      <!-- Year -->
      <div class="filter-section">
        <label class="filter-label">
          <i class="fa-solid fa-calendar-days"></i>
          {{'select_the_reporting_year' | translate }}
        </label>
        <div class="dropdown-wrapper">
          <p-dropdown (onChange)="changeYear()" [options]="years" [(ngModel)]="selectedYear" optionLabel="name"
            placeholder="{{'select_the_reporting_year' | translate }}"></p-dropdown>
        </div>
      </div>

      <!-- Department -->
      <div class="filter-section">
        <label class="filter-label">
          <i class="fa-solid fa-building-user"></i>
          {{'the_department' | translate }}
        </label>
        <div class="dropdown-wrapper">
          <p-dropdown filter="true" filterBy="name" (onChange)="departmentChange()" [(ngModel)]="selectedDepartment"
            [options]="departments" optionLabel="name" placeholder="{{'select_the_department' | translate }}"></p-dropdown>
        </div>
      </div>

      <!-- Section -->
      <div class="filter-section">
        <label class="filter-label">
          <i class="fa-solid fa-sitemap"></i>
          {{'the_section' | translate }}
        </label>
        <div class="dropdown-wrapper">
          <p-dropdown filter="true" filterBy="name" (onChange)="sectionChange()" [(ngModel)]="selectedSectionId"
            [options]="filteredSections" optionLabel="name" optionValue="id"
            placeholder="{{'select_the_section' | translate }}"></p-dropdown>
        </div>
      </div>

      <!-- Initiative -->
      <div class="filter-section">
        <label class="filter-label">
          <i class="fa-solid fa-diagram-project"></i>
          {{'the_initiative' | translate }}
        </label>
        <div class="dropdown-wrapper">
          <p-dropdown filter="true" (onChange)="projectChange()" [(ngModel)]="selectedProjectId"
            [options]="filteredProjects" optionLabel="name" optionValue="id"
            placeholder="{{'select_the_initiative' | translate }}">
            <ng-template pTemplate="item" let-item>
              <div class="flex gap-2 align-items-center">
                <div class="flex flex-column align-items-start gap-2">
                  <div class="font-bold" [title]="item.name">
                    {{item.name|substring:40}}
                  </div>
                </div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>

  @if(selectedProjectId==0){
  <div class="stats-grid">
    @for(card of performnceCards;track card)
    {
    <div class="stat-card-wrapper" (click)="isModalVisable(card.id)">
      <app-performance-card [name]="card.name" [icon]="card.icon" [count]="card.count"></app-performance-card>
    </div>
    }
  </div>

  <!-- Comparison Charts Section -->
  <div class="charts-section">
    <h2 class="section-title">
      <i class="fa-solid fa-chart-line"></i>
      {{ 'performance_comparison' | translate }}
    </h2>

    <div class="charts-grid">
      <!-- Chart 1: Strategic Hierarchy with Progress Bars -->
      <div class="chart-card-wrapper">
        <div class="chart-card">
          <h3 class="chart-card-title">
            <i class="fa-solid fa-sitemap"></i>
            {{ dir === 'rtl' ? 'التسلسل الهرمي الاستراتيجي' : 'Strategic Hierarchy' }}
          </h3>
          <div class="strategic-progress-container">
            <!-- Goals Progress -->
            <div class="progress-item">
              <div class="progress-header">
                <span class="progress-label">
                  <i class="fa-solid fa-bullseye"></i>
                  {{ dir === 'rtl' ? 'الأهداف' : 'Goals' }}
                </span>
                <span class="progress-value">{{ performnceCards[0]?.count || 0 }}</span>
              </div>
              <div class="progress-bar-wrapper">
                <div class="progress-bar goals-progress" 
                     [style.width.%]="getProgressPercentage(performnceCards[0]?.count || 0)">
                </div>
              </div>
            </div>

            <!-- Indicators Progress -->
            <div class="progress-item">
              <div class="progress-header">
                <span class="progress-label">
                  <i class="fa-solid fa-chart-line"></i>
                  {{ dir === 'rtl' ? 'المؤشرات' : 'Indicators' }}
                </span>
                <span class="progress-value">{{ performnceCards[1]?.count || 0 }}</span>
              </div>
              <div class="progress-bar-wrapper">
                <div class="progress-bar indicators-progress" 
                     [style.width.%]="getProgressPercentage(performnceCards[1]?.count || 0)">
                </div>
              </div>
            </div>

            <!-- Projects Progress -->
            <div class="progress-item">
              <div class="progress-header">
                <span class="progress-label">
                  <i class="fa-solid fa-rocket"></i>
                  {{ dir === 'rtl' ? 'المبادرات' : 'Projects' }}
                </span>
                <span class="progress-value">{{ performnceCards[2]?.count || 0 }}</span>
              </div>
              <div class="progress-bar-wrapper">
                <div class="progress-bar projects-progress" 
                     [style.width.%]="getProgressPercentage(performnceCards[2]?.count || 0)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Chart 2: Total Projects vs Pending -->
      <div class="chart-card-wrapper">
        <div class="chart-card">
          <h3 class="chart-card-title">
            <i class="fa-solid fa-rocket"></i>
            {{ dir === 'rtl' ? 'المبادرات الكلية مقابل قيد التقييم' : 'Total vs Pending Projects' }}
          </h3>
          <apx-chart
            [series]="projectsComparisonChart.series"
            [chart]="projectsComparisonChart.chart"
            [colors]="projectsComparisonChart.colors"
            [labels]="projectsComparisonChart.labels"
            [legend]="projectsComparisonChart.legend"
            [dataLabels]="projectsComparisonChart.dataLabels"
            [plotOptions]="projectsComparisonChart.plotOptions"
            [responsive]="projectsComparisonChart.responsive"
            [tooltip]="projectsComparisonChart.tooltip"
            [stroke]="projectsComparisonChart.stroke">
          </apx-chart>
        </div>
      </div>

      <!-- Chart 3: Projects Status Distribution -->
      <div class="chart-card-wrapper">
        <div class="chart-card">
          <h3 class="chart-card-title">
            <i class="fa-solid fa-chart-pie"></i>
            {{ dir === 'rtl' ? 'توزيع حالة المبادرات' : 'Projects Status Distribution' }}
          </h3>
          <apx-chart
            [series]="projectsStatusChart.series"
            [chart]="projectsStatusChart.chart"
            [colors]="projectsStatusChart.colors"
            [labels]="projectsStatusChart.labels"
            [legend]="projectsStatusChart.legend"
            [dataLabels]="projectsStatusChart.dataLabels"
            [plotOptions]="projectsStatusChart.plotOptions">
          </apx-chart>
        </div>
      </div>
    </div>
  </div>
  }
  @else {
  <div class="stats-grid">
    @for(card of projectCards;track card.name)
    {
    <div class="stat-card-wrapper" (click)="isProjectModalVisable(card.id)">
      @if(card.id=="resource")
      {
      <app-performance-card [name]="card.name" [type]="card.id" [icon]="card.icon"
        [count]="card.count"></app-performance-card>
      }@else{
      <app-performance-card [name]="card.name" [icon]="card.icon" [count]="card.count"></app-performance-card>
      }
    </div>
    }
  </div>


  <div class="grid align-items-stretch mt-5">
    <div class="lg:col-4 col-12 align-self-stretch">
      <div class="chart-card">
        <h3 class="chart-title">
          <i class="fa-solid fa-chart-pie"></i>
          {{'Progress Percentage'|translate}}
        </h3>
        <div id="chart">
          <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
            [plotOptions]="chartOptions.plotOptions" [labels]="chartOptions.labels" [stroke]="chartOptions.stroke"
            [fill]="chartOptions.fill">
          </apx-chart>
        </div>
      </div>
    </div>
    <div class="lg:col-8 col-12 align-self-stretch">
      <div class="team-card">
        <h3 class="team-title">
          <i class="fa-solid fa-users"></i>
          {{'team_members' | translate}}
        </h3>
        <div class="team-grid">
          @for(member of selectedProject.teamMembers;track member){
            <div class="team-member">
              <i [class]="!member?.is_in_charge ? 'fa-solid fa-user member-icon' : 'fa-solid fa-user-gear member-icon in-charge'"></i>
              <span [class]="member?.is_in_charge ? 'member-name in-charge' : 'member-name'">{{member.name}}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  }
</div>


<p-dialog [modal]="true" [(visible)]="visible" [style]="{ width: '80rem',   Height:'80rem'}"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">
  <ng-template pTemplate="header">
    <div class="flex justify-content-between align-items-center w-full">
      <div class="font-bold text-xl g-c-primaryDarkerColor">
        {{modalHeaderName}}
      </div>
      <button class="modal-back-btn" (click)="visible = false" pTooltip="{{'back'|translate}}" tooltipPosition="left">
        @if(dir=='rtl'){
        <i class="fa-solid fa-arrow-right"></i>
        }@else{
        <i class="fa-solid fa-arrow-left"></i>
        }
        <span>{{'back'|translate}}</span>
      </button>
    </div>
  </ng-template>
  <div>
    @switch (selectedModalType) {
    @case("goals"){

    <div class="goals  justify-content-evenly grid mt-5 ">

      <!-- @for(goal of goals;track goal)
      {
      <div class="lg:col-6  md:col-12 col-12">
        <app-goals [selectedStrategyId]="selectedStrategyId" [goal]="goal"></app-goals>
      </div>
      } -->
      <app-goals [selectedStrategyId]="selectedStrategyId" [goals]="goals" [isModal]="true" 
                 (onIndicatorsClick)="openIndicatorsModal()" 
                 (onProjectsClick)="openProjectsModal()"></app-goals>
    </div>
    }
    @case("indicators"){
    <div class="indicators grid mt-5 justify-content-center ">
      @for(indicator of indicators;track indicator)
      {
      <div class=" lg:col-6 md:col-12 col-12 ">
        <app-shared-indicator [indicator]="indicator" [selectedStrategyId]="selectedStrategyId" [isClickable]="false"></app-shared-indicator>
      </div>
      }
    </div>
    }
    @case("projects"){

    <div class="grid gap-8  mt-5 justify-content-center ">
      <app-shared-project [projects]="projects" [isDeleteAllowed]="false" [isClickable]="false"
        [strategyId]="selectedStrategyId"></app-shared-project>
    </div>

    }
    @case("finishedProjects"){
    <app-shared-project [projects]="finishedProjects" [isDeleteAllowed]="false" [isClickable]="false"
      [strategyId]="selectedStrategyId"></app-shared-project>
    }
    @case("lateProjects"){
    <app-shared-project [projects]="lateProjects" [isDeleteAllowed]="false" [isClickable]="false"
      [strategyId]="selectedStrategyId"></app-shared-project>



    }
    @case("onGoingProjects"){
    <div class="grid  gap-8 mt-5 justify-content-center ">
      <app-shared-project [projects]="onGoingProjects" [isDeleteAllowed]="false" [isClickable]="false"
        [strategyId]="selectedStrategyId"></app-shared-project>
    </div>

    }
    }
  </div>
</p-dialog>
<p-dialog [modal]="true" [(visible)]="isProjectVisable" [style]="{ width: '80rem',   height:'500rem'}"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">

  <ng-template pTemplate="header">
    <div class="flex justify-content-between align-items-center w-full">
      <div class="font-bold text-xl g-c-primaryDarkerColor">
        {{modalHeaderName}}
      </div>
      <button class="modal-back-btn" (click)="isProjectVisable = false" pTooltip="{{'back'|translate}}" tooltipPosition="left">
        @if(dir=='rtl'){
        <i class="fa-solid fa-arrow-right"></i>
        }@else{
        <i class="fa-solid fa-arrow-left"></i>
        }
        <span>{{'back'|translate}}</span>
      </button>
    </div>
  </ng-template>
  <div>
    @switch (selectedModalType) {
    @case("resource"){

    <div class="mt-5">
      @if(selectedProject.resource.budget_items.length){
      <p-table [class]="dir" styleClass="p-datatable-striped" [value]="selectedProject.resource.budget_items"
        [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5, 10, 20]" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>

            <th>
              {{'report_budget_item'|translate}}

            </th>
            <th>
              {{'report_budget_amount'|translate}}

            </th>
            <th>
              {{'report_budget_description'|translate}}
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-index>
          @if(!item.is_deleted){
          <tr>

            <td>
              {{item['name']}}
            </td>
            <td>
              {{item['value'] | currency:'AED'}}
            </td>
            <td>
              {{item['description']}}
            </td>
          </tr>
          }
        </ng-template>
      </p-table>
      }@else{
      <div class="font-bold  text-center text-red-500 text-2xl">لا توجد بنود </div>
      }
    </div>

    }



    @case("milestones"){

    <div class="mt-5">
      <p-table [class]="dir" styleClass="p-datatable-striped" [value]="selectedProject.milestones" [paginator]=" true"
        [rows]="5" [rowsPerPageOptions]="[5, 10, 20]" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>
              {{'milestone' | translate}}
            </th>
            <th>
              {{'description' | translate}}
            </th>

            <th>
              {{'outputs' | translate}}
            </th>
            <th>
              {{'implementation_period' | translate}}
            </th>
            <th>
              {{'milestone_kpi' | translate}}
            </th>
            <th>
              {{'stage_status' | translate}}
            </th>
            <th>
              {{'positive_or_negative' | translate}}
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-milestone>
          <tr>
            <td>
              {{milestone.name}}
            </td>
            <td>
              {{milestone.description}}
            </td>
            <td>
              {{milestone.outputs}}
            </td>
            <td>
              <div class="mb-2" style="min-width: 10rem;">
                <span class="font-semibold">من:</span> {{milestone.start_date|date}}

              </div>
              <div style="min-width: 10rem;">
                <span class="font-semibold">الي:</span> {{milestone.end_date|date}}

              </div>

            </td>
            <td>
              {{milestone.indicator_name}}
            </td>
            <td>
              @if(milestone.is_done){
              <p-tag severity="success" value="نفذت" />

              }@else{
              <p-tag severity="warning" value="قيد التنفيذ" />
              }
            </td>
            <td>
              @if(milestone.is_positive){
              <p-tag severity="success" value="ايجابية" />

              }@else{
              <p-tag severity="danger" value="سلبية" />
              }

            </td>

          </tr>
        </ng-template>
      </p-table>
    </div>

    }


    @case("risks"){
    <div class="mt-5">
      <p-table [class]="dir" styleClass="p-datatable-striped" [value]="selectedProject.risks" [paginator]="true"
        [rows]="5" [rowsPerPageOptions]="[5, 10, 20]" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>
              {{'risk'|translate}}

            </th>
            <th>
              {{'description'|translate}}

            </th>
            <th>

              {{'likelihood'|translate}}
            </th>
            <th>

              {{'impact'|translate}}
            </th>
            <th>
              {{'risk_weight'|translate}}

            </th>
            <th>
              {{'preventive_action'|translate}}
            </th>
            <th>

              {{'reponsible_risk'|translate}}
            </th>
            <th>

              {{'risk_type'|translate}}
            </th>


          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-risk>
          <tr>
            <!-- <p-overlayPanel #op>
                            <div class="relative">
                                {{risk.description}}
                            </div>
                        </p-overlayPanel> -->
            <td>
              {{risk.name}}
            </td>
            <td class="relative">
              <div style="position: relative">
                <div class="cursor-pointer">
                  {{risk.description}}
                  <!-- @if(risk.description.length>50)
                                    {
                                    ...
                                    } -->
                </div>
              </div>
            </td>
            <td>
              {{risk.likelihood_name}}
            </td>
            <td>
              {{risk.impact_name}}
            </td>


            <td>
              <p-tag [style]="{'background-color':getWeightColor(risk.weight)}" value="{{risk.weight}}/25" />
            </td>

            <td>
              {{risk.action}}
            </td>
            <td>
              {{risk.in_charge_name}}
            </td>
            <td>
              {{risk.type_name}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    }
    }



  </div>
</p-dialog>


<ng-template #textLengthToolTip>
  <div class="flex align-items-center">
    <span i18n>اضغط لرؤية المزيد</span>
  </div>
</ng-template>